<template>
  <div class="service-health-container">
    <a-spin :spinning="spinning">
      <bar-chart-usage-top
        v-if="chartData.length"
        unit="分"
        :chart-data="chartData"
        :bar-color="barColor"
        :bg-color="bgColor"
        :height="260"
        :eventList="[
          {
            type: 'element:click',
            func: chartClick
          }
        ]"
        chart-id="virtual-machine-storage-usage-chart"
      ></bar-chart-usage-top>
      <div v-else style="min-height: 264px; position: relative; overflow: hidden;">
        <empty-component
          description="暂无数据"
          :imgUrl="require('@/assets/images/info_empty.png')"
          :body-style="{
            height: '176px',
            marginTop: '28px'
          }"
          :description-style="{
            marginTop: '-24px'
          }"
        ></empty-component>
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import { getServiceTop } from '@/api/service'
import BarChartUsageTop from '@/components/top/BarChartUsageTop.vue'
import EmptyComponent from '@/components/EmptyComponent.vue'

export default {
  name: 'ServiceHealth',
  components: {
    BarChartUsageTop,
    EmptyComponent
  },
  data () {
    return {
      chartData: [],
      spinning: false,
      barColor: this.barColorFunc,
      bgColor: this.bgColorFunc,
      params: {
        datetime_from: moment().subtract(7, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        top_of: 'health',
        limit: 5
      }
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.spinning = true
      getServiceTop(this.params).then(res => {
        if (res.data) this.chartData = res.data.data.sort((a, b) => a.value - b.value)
        else this.chartData = []
      }).finally(() => { this.spinning = false })
    },
    bgColorFunc (val) {
      if (val >= 80) return '#43B94D20'
      else if (val >= 60) return '#fa8c1620'
      else return '#f5222d20'
    },
    barColorFunc (val) {
      if (val >= 80) return 'l(90) 0:#97fc9f 1:#43B94D'
      else if (val >= 60) return 'l(90) 0:#ffdd9a 1:#fa8c16'
      else return 'l(90) 0:#ffa3a8 1:#f5222d'
    },
    chartClick (e) {
      const id = e.data ? e.data.data.id : ''
      if (id) this.$router.push({ name: 'ServiceDashboardDetail', params: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
.service-health-container {}
</style>
